export default {
  //Item photo
  Photo: "Photo",
  ChoosePhoto: "Choose photo",
  RemovePhoto: "Remove photo",
  //Order panel
  CurrentOrder: "Current order",
  NoItemsYet: "No items yet",
  TapAnItemToAddIt: "Tap an item to add it to the order",
  //Login
  SetOwnerPin: "Set Owner Pin",
  SetPin: "Set Pin",
  EnterValidName: "Enter Valid Name",
  PinMustBeExactly4Characters: "Pin must be exactly 4 characters",
  PinCodeDoesNotMatch: "Pin Code Does Not Match",
  //Drawer
  Sales: "Sales",
  Receipts: "Receipts",
  Listings: "Listings",
  Shift: "Shift",
  ShiftReports: "Shift Reports",
  Settings: "Settings",
  LogoutAttendant: "Logout Attendant",

  //Sales
  Subtotal: "Subtotal",
  Tax: "Tax",
  Discounts: "Discounts",
  TotalPayment: "Total Payment",
  Favorites: "Favorites",
  All: "All",
  Payment: "Payment",
  ItemFavorites: "Item Favorites",
  WouldYouLikeToIncludeTheItemAsFavorites:
    "Would you like to include the item as favorite?",
  WouldYouLikeToRemoveTheItemAsFavorites:
    "Would you like to remove the item as favorite?",
  EditPrice: "Edit Price",
  SetPrice: "Set Price",
  EditTransactionLine: "Edit Transaction Line",
  Quantity: "Quantity",
  SetQuantity: "Set Quantity",
  Set: "Set",
  SetCommission: "Set Commission",
  Add: "Add",
  ReceiptLineIsDeleted: "Receipt Line is Deleted",
  Okay: "Okay",
  ItIsNotYourShift: "It is not your shift",

  //Sales Delete Icon
  ConfirmDelete: "Confirm Delete",
  AreYouSureToDeleteReceiptLines: "Are you sure to delete receipt lines?",
  No: "No",
  Yes: "Yes",

  //Sales Discount Icon
  Discount: "Discount",
  PleaseAddAnItem: "Please add an item",
  OK: "OK",
  OnTheFlyDiscount: "On The Fly Discount",
  ExistingDiscount: "Existing Discount",
  DiscountType: "Discount Type",
  Percentage: "Percentages",
  SetDiscount: "Set Discount",
  FixDiscount: "Fix Discount",
  CurrentDiscountSelected: "Current Discount Selected",
  NoSelectedDiscount: "No discount selected",
  SelectNewDiscount: "Select New Discount",

  //Sales Search
  SearchItems: "Search Items",

  //Sales View Orders
  ViewOrders: "View Orders",
  NoOrdersYet: "No Orders Yet",
  ConfirmOrder: "Confirm Order",
  SelectOrderType: "Select Order Type",
  Cancel: "Cancel",
  Confirm: "Confirm",
  AnyPendingTransactionsWillBeOverridedWouldYouLikeToContinue:
    "Any Pending Transactions Will Be Overrided. Would you like to continue?",
  Orders: "Orders",
  ORDER: "ORDER",
  CancelOrder: "Cancel Order",
  TableNo: "Table No",
  TableNumber: "Table Number",
  ChangeTable: "Change Table",
  ReprintOrder: "Reprint Order",

  //Payment
  Pay: "Pay",
  AmountDue: "Amount Due",
  AmountChange: "Amount Change",
  Customer: "Customer",
  PaymentType: "Payment Type",
  PrinterStatus: "PrinterStatus",
  NoDefaultPrinter: "No Default Printer",
  AddCustomer: "AddCustomer",
  Cash: "Cash",
  Card: "Card",
  ConfirmPayment: "Confirm Payment",
  AreYouSure: "Are you sure?",
  Proceed: "Proceed",
  ReceiptInformation: "Receipt Information",
  DoYouWantToPrintReceipt: "Do you want to print receipt",
  Close: "Close",
  TransactionSummary: "Transaction Summary",
  CashPaid: "Cash Paid",
  Commission: "Commission",
  Alert: "Alert",
  AmountPaidMustBeGreaterThanOrEqualToAmuntDue:
    "Amount Paid must be greater than or equal to Amount Due",
  Email: "Email",
  PhoneNumber: "Phone Number",
  Note: "Note",
  Save: "Save",
  NoAddedPrinterDevice: "No added printer device",

  //Receipt
  NoReceiptsAvailable: "No receipts available",
  Receipt: "Receipt",
  Completed: "Completed",
  Attendant: "Attendant",
  Offline: "Offline",
  Reprint: "Reprint",
  CancelReceipt: "Cancel Receipt",
  SoldTo: "Sold to",
  Total: "Total",
  NoTax: "No tax",
  NoDiscount: "No discount",
  AmountPaid: "Amount Paid",
  Transaction: "Transaction",
  VoidReceipt: "Void Receipt",
  AreYouSureYouWantToVoidReceipt: "Are you sure you want to void receipt?",
  Reason: "Reason",
  Cancelled: "Cancelled",

  //Listings
  Items: "Items",
  Item: "Item",

  Categories: "Categories",
  WouldYouLikeToCreateNewItem: "Would you like to create new item?",
  WouldYouLikeToCreateNewCategory: "Would you like to create new category?",
  WouldYouLikeToCreateNewDiscount: "Would you like to create new discount?",
  CreateNewItem: "Create new item",
  CreateNewCategory: "Create new category",
  CreateNewDiscount: "Create new discount",

  //Listings Items
  Category: "Category",
  NoCategory: "No Category",
  Price: "Price",
  Barcode: "Barcode",
  SoldBy: "Sold by",
  Each: "Each",
  Weight: "Weight",
  OtherInformation: "Other Information",
  SKU: "SKU",
  StockKeepingUnit: "Stock Keeping Unit",
  Color: "Color",
  Shape: "Shape",
  ShowOptions: "Show Options",
  PrintBarcode: "Print Barcode",
  HideOptions: "Hide Options",
  SaveNewItem: "Save new item",
  SuccessfullyAddedNewItem: "Successfully added new item",

  //Listings categories
  CategoryName: "Category Name",
  ColorWillApplyToAllItemsUnderThisCategoryForWhichColorIsNotSet:
    "Color will apply to all items under this category for which color is not set",
  SaveNewCategory: "Save new category",
  EnterValidCategoryName: "Enter Valid Category Name",
  EnterValidDiscountName: "Enter Valid Discount Name",
  EnterAValidItemName: "Enter a Valid Item Name",
  EnterValidDiscountValue: "Enter Valid Discount Value",
  SuccessfullyAddedCategory: "Successfully Added Category",
  SuccessfullyAddedDiscount: "Successfully Added Discount",

  //Listings Discounts
  DiscountName: "Discount Name",
  DiscountValue: "Discount Value",
  Role: "Role",

  //Shift
  InputValidReason: "Input valid reason",
  AddedCash: "Added Cash",
  CashPayoutIsGreaterThanTheCashAvailable:
    "Cash Payout is greater than the cash available",
  RemovedCash: "Removed Cash",
  ShiftDetails: "Shift details",
  Amount: "Amount",
  Payin: "Pay-in",
  Payout: "Pay-out",
  ShiftStarted: "Shift started",
  ShiftStartedOn: "Shift started on",
  BeginningCash: "Beginning Cash",
  EndingCash: "Ending Cash",
  ShiftOpenedBy: "Shift opened by",
  CloseShift: "Close Shift",
  TheCashYouWantedToPutIntoTheRegisterOrGetOutFromTheRegister:
    "The cash you wanted to pur into the register or get out grom the register.",
  ActualMoney: "ActualMoney",
  SetActualMoney: "Set Actual Money",
  InvalidAmount: "Invalid Amount",
  EndedShift: "Ended Shift",
  WorkedFor: "Worked for",
  AndEndedOn: "and ended on",
  StartAnotherShift: "Start Another Shift",
  TheCashByTheStartOfTheShift: "The cash by the start of the shift",
  EnterABeginningCash: "Enter a beginning cash",

  //Shift Reports
  ItemSalesReport: "Items Sales Report",
  CommissionReport: "Commission Report",
  GenerateZReading: "Generate Z Reading",
  NoZReadingGenerated: "No Z Reading Generated",
  ZReading: "Z Reading",
  ZReadin: "Z Reading",
  Opened: "Opened",
  By: "by",
  by: "by",
  TotalNetSales: "Total Net Sales",
  Transactions: "Transactions",
  OpeningAmount: "Opening Amount",
  ExpectedDrawer: "Expected Drawer",
  Short: "Short",
  CashSales: "Cash Sales",
  Payouts: "Payouts",
  Payins: "Pay Ins",
  Taxes: "Taxes",
  Commissions: "Commissions",
  PrintXReport: "Print X Report",
  ShiftInfo: "Shift Info",
  PrintReport: "Print Report",
  PrintCommissions: "Print Commissions",
  Name: "Name",
  PrintZReport: "Print Z Report",

  //Settings
  //Bluetooth
  Bluetooth: "Bluetooth",
  Company: "Company",
  Sync: "Sync",
  Queueing: "Queueing",
  Printer: "Printer",
  RegisteredDevices: "Registered Devices",
  AvailableDevices: "Available Devices",
  BluetoothScanner: "Bluetooth Scanner",
  Enable: "Enable",
  Connected: "Connected",
  Connecting: "Connecting...",
  NotConnected: "Not Connected",
  AddDevice: "Add Device",
  AreYouSureYouWantToAddThisDevice: "Are you sure you want to add this device?",
  AreYouSureYouWantToRemoveThisDevice:
    "Are you sure you want to remove this device?",
  SuccessfullyAddedDevice: "Successfully Added Device",
  SuccessfullyRemovedDevice: "Successfully Removed Device",
  RemoveDevice: "Remove Device",

  //Company
  CompanySettings: "Company Settings",
  Currency: "Currency",
  CompanyHeader: "Company Header",
  CompanyFooter: "Company Footer",
  CurrentlyEditingPleaseSaveYourChanges:
    "Currently editing. Please save your changes",

  //Attendant
  AddRole: "Add Role",
  AttendantName: "Attendant Name",
  CanLogin: "Can Login",
  SaveAttendant: "Save Attendant",
  Pin: "Pin",
  ConfirmPin: "Confirm Pin",
  SuccessfullyAddedAttendant: "Successfully Added Attendant",
  EnterValidPin: "Enter Valid Pin",
  PleaseConfirmPin: "Please Confirm Pin",

  //Sync
  Server: "Server",
  SyncSettings: "Sync Settings",
  Username: "Username",
  Password: "Password",
  DeviceID: "Device ID",
  PleaseClickTheEditButton: "Please click the edit (pencil icon) button",
  EnterValidAttendantName: "Enter Valid Attendant Name",
  //Queueing
  OtherSettings: "Other Settings",
  UseDescription: "Use Description",
  DescriptiveItemNamesInTheListing: "Descriptive item names in the listing",
  UseDefaultCustomer: "Use Default Customer",
  SetItemStacking: "Set Item Stacking",
  Use: "Use",
  EnableThe: "Enable the",
  Feature: "feature",
  HostAddress: "Host Address",

  //Logout
  ConfirmLogout: "Confirm Logout",
  AreYouSureYouWantToLogout: "Are you sure you want to logout?",

  //Select Attendant
  SelectAttendant: "Select Attendant",
  Next: "Next",
  None: "None",
  EnterPin: "Enter PIN",
  NoAttendant: "No Attendant",
  PleaseSelectAnyAttendant: "Please Select Any Attendant",
  PINError: "PIN Error",
  PleaseEnterTheCorrectPINNumber: "Please enter the correct PIN number",

  //Late Additionals
  SetTheShift: "Set the shift",
  AttendantAlreadyAdded: "Attendant Already Added",
  NoItemBasedOnTheBarcode: "No item based on the barcode",
  QuantityIsNotAllowed: "Quantity is not allowed",
  ReceiptLineIsModified: "Receipt line is modified",
  UnableToDeleteReceiptLine: "Unable to delete receipt line.",
  ConfirmOrderCancel: "Confirm Order Cancel",
  ConfirmOrderClose: "Confirm Order Close",
  WouldYouLikeToCancelTheOrder: "Would you like to cancel the order?",
  WouldYouLikeToCloseTheOrder: "Would you like to close the order?",
  IsCancelled: "is cancelled",
  Order: "Order",
  ConfirmTableChange: "Confirm Table Change",
  WouldYouLikeToChangeTable: "Would you like to change table?",
  TableNumberChanged: "Table Number Changed",
  UnableToTakeAwayOrder: "Unable to take-away order.",
  SaveNew: "Save new",
  Edit: "Edit",
  VerifyCode: "Verify code",
  Verify: "Verify",
  ResendCode: "Resend Code",
  CashedOut: "Cashed Out",
  TaxPercentage: "Tax Percentage",
  ItemName: "Item Name",
  AddNewItem: "Add new item",
  WouldYouLikeToCreateNew: "Would you like to create new",
  CreateNew: "Create new",
  From: "From",
  To: "To",
  EnterPinCode: "Enter PIN Code",
  ZeroPriceIsNotAvailable: "Zero price is not available.",
  PaymentReceipt: "Payment Receipt",
  TransactedOn: "Transacted on",
  YouHaveSuccessfullyRegistered: "You have successfully registered",
  ReceiptItems: "Receipt Items",
  Overage: "Overage",
  ErrorButton: "Error Button",
  ForceSync: "Force Sync",
  SyncingErpnextData: "Syncing ERPNEXT data",
  SendPassword: "Send Password",
  Back: "Back",
  Register: "Register",
  Login: "Login",
  CreateAccount: "Create Account",
  FirstName: "First Name",
  LastName: "Last Name",
  ConfirmPassword: "Confirm Password",
  ThereAreItemsAssociatedWithThisCategoryChangeOrDeleteTheItems:
    "There are items associated with this category. Change or delete the items",
  SuccessfullyDeletedCategory: "Successfully Deleted Category",
  SuccessfullyDeletedItem: "Successfully Deleted Item",
  SuccessfullyDeletedDiscount: "Successfully Deleted Discount",
  DeleteCategory: "Delete Category?",
  DeleteItem: "Delete Item?",
  DeleteDiscount: "Delete Discount?",
  WouldYouLikeToDeleteThisCategory: "Would you like to delete this category?",
  WouldYouLikeToDeleteAnItem: "Would you like to delete an item?",
  WouldYouLikeToDeleteThisDiscount: "Would you like to delete this discount?",
  SuccessfullyUpdatedCategory: "Successfully Updated Category",
  SuccessfullyUpdatedItem: "Successfully Updated Item",
  SuccessfullyUpdatedDiscount: "Successfully Updated Discount",
  DiscountValueError: "Discount Value Error",
  ValueCantBeGreaterThan100OrLessThan0:
    "Value cant be greater than 100% or less than 0%",
  BarcodeAlreadyBeenUsed: "Barcode already been used",
  EnterValidItemName: "Enter Valid Item Name",
  SuccessfullyPrintedTheBarcode: "Successfully printed the barcode.",
  UnableToPrint: "Unable to print",
  PleaseConnectYourPrinter: "Please connect your printer",
  CheckYourEmail: "Check Your Email.",
  NetworkConnectionFailed: "Network Connection Failed.",
  ReceiptConfirmation: "Receipt Confirmation",
  InvalidEmail: "Invalid Email",
  PleaseEnterValidEmail: "Please enter valid email",
  AreYouSureYouWantToReprintThisReceipt:
    "Are you sure you want to reprint this receipt?",
  UnableToConnectPrinter: "Unable to connect printer",
  ReprintCompleted: "Reprint Completed",
  EnterValidReason: "Enter Valid Reason",
  TransactionCompleted: "Transaction Completed",
  AllDataWillBeLostWhenYouAreLoggedOutAsOwnerWouldYouLikeToProceed:
    "All data will be lost when you are logged out as owner. Would you like to proceed?",
  Logout: "Logout",
  AttendantAlreadyExists: "Attendant Already Exists",
  SuccessfullyUpdatedAttendant: "Successfully updated attendant",
  PinCodeContainsSpecialCharacters: "Pin code contains special characters",
  DeleteAttendant: "Delete Attendant",
  AreYouSureYouWantToDeleteAttendant:
    "Are you sure you want to delete attendant?",
  SuccessfullyDeletedAttendant: "Successfully Deleted Attendant",
  NoShiftsCreated: "No Shifts Created",
  BluetoothConnectionFailed: "Bluetooth Connection Failed",
  RoleError: "Role Error",
  UnableToGoToListingIfYouAreTheOwnerReLogInAsOwnerInOrderToProceed:
    "Unable to go to listing. If you are the owner, re log-in as owner in order to proceed",
  UnableToRegisterEmailAddressIsAlreadyTaken:
    "Unable to register. Email address is already taken",
  UnableToRegisterConnectionFailed: "Unable to register. Connection failed",
  EmailAlreadyExists: "Email Already Exists",
  EmailIsAvailable: "Email is available",
  InputAValidEmail: "Input a valid email",
  OpenShift: "Open Shift",
  InputValidRole: "Input Valid Role",
  SuccessfullyDeletedRole: "Successfully Deleted Role",
  DeleteRole: "Delete Role",
  AreYouSureYouWantToDeleteRole: "Are you sure you want to delete role?",
  SuccessfullyAddedRole: "Successfully Added Role",

  //Actual Receipts
  Cashier: "Cashier: ",
  TransactionNo: "Transaction No.:",
  Qty: "Qty",
  Purchases: "Purchases",
  TotalAmount: "Total Amount",
  ThisServesAsYour: "This serves as your",
  OfficialReceipt: "Official Receipt",
  POSProvider: "POS Provider:\n",
  AccredNo: "Accred. No.: \n",
  DateIssued: "Date Issued: \n",
  ValidUntil: "Valid Until: \n\n",
  ThisReceiptShallBeValidFor: "THIS RECEIPT SHALL BE VALID FOR\n",
  FiveYearsFromTheDateOf: "FIVE(5) YEARS FROM THE DATE OF\n",
  ThePermitToUse: "THE PERMIT TO USE\n",
  FromDateMustBeGreaterThanOrEqualToDate:
    "(From) date must be greater than or equal (To) date",
  NoItemSalesFrom: "No Item Sales from",
  Date: "Date",
  Type: "Type",
  PrintedBy: "Printed by",
  Closed: "Closed",
  PrintedOn: "Printed on",
  Change: "Change",
  XRreading: "X Reading",
  Language: "Language",
  PleaseRestartTheApplicationToUpdateLanguage:
    "Please restart the application to update language",
  AlreadyUpToDate: "Already up to date",
  SyncSuccessful: "Sync Successful",
  UnableToSync: "Unable to sync",
  InvalidUrl: "Invalid URL",
  CompanySettingsSaved: "Company Settings Saved",
  RestoreDefault: "Restore Default",
  AreYouSureYouWantToRestoreDefaultSettings:
    "Are you sure you want to restore default settings?",
  DefaultSettingsRestored: "Default Settings Restored",
};
